<template>
  <div class="mainNews">
    <div class="container">
      <div class="sectionTitle">
        <p class="title">FEEDS</p>
      </div>

      <div class="tabBtn">
        <button
          v-for="(item, index) in types"
          :key="index"
          type="button"
          class="btn"
          :class="{active: item.active}"
          @click.stop="getNews(item.id)">
          {{ item.name }}
        </button>
      </div>
    </div>

    <div v-if="list" class="gridList">
      <masonry :cols="{default: 2, 700: 2, 400: 2}"
               :gutter="{default: '18px', 700: '18px', 400: '15px'}">
        <div
          v-for="(item, index) in list"
          :key="index"
          class="feedItem">
          <span :class="['icon', item.sns_type === 'instagram' ? 'instagram' : item.sns_type === 'youtube' ? 'youtube' : '']"></span>
          <a :href="item.link_url" :target="item.sns_type === 'instagram' || item.sns_type === 'youtube' ? '_blank' : '_self'">
           <div class="link">
             <img
                 class="bg"
                 :src="item.thumbnail_img"
                 :alt="item.description_short"
                 @error="replaceByDefaultImg"
             />
             <!--<div class="title">{{ item.title }}</div>-->
             <div class="infoBox">
               <ul v-if="item.description_short">
                 <li class="title">
                   <p>{{ item.description_short }}</p>
                 </li>
               </ul>
             </div>
           </div>
          </a>
        </div>
      </masonry>
    </div>
    <div v-if="list.length === 0" class="noData">게시물이 없습니다.</div>
  </div>
</template>

<script>

export default {
  name : 'News',
  data() {
    return {
      list: [],
      types: [
        {
          id: 'all',
          name: '전체',
          route: 'feedsAll',
          active: true
        },
        {
          id: 'news',
          name: '구단소식',
          route: 'feedsNews',
          active: false
        },
        {
          id: 'review',
          name: '프리뷰·리뷰',
          route: 'review',
          active: false
        },
        {
          id: 'notice',
          name: '공지사항',
          route: 'notice',
          active: false
        },
        {
          id: 'youtube',
          name: '유튜브',
          route: 'youtube',
          active: false
        },
        {
          id: 'instagram',
          name: '인스타그램',
          route: 'instagram',
          active: false
        }
      ]
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.getNews('all')
    },
    getLink (item) {
      const type = item && item.type
      const routeName = type && this.types.find(x => x.id === type) && this.types.find(x => x.id === type).route
      const id = item.id
      return routeName && id
        ? { name: `${routeName}View`, params: { id: id } }
        : '/'
    },
    async getNews (type) {
      // 탭 메뉴 변경 시 목록 / 목록 안에 active
      const list = {
        news: [],
        youtube: [],
        // facebook: [],
        instagram: []
      }

      let _type = '';
      if (type !== 'all') {
        _type = '?type=' + type;
      }
      const feedsList = await this.$http.get(`/notice/feeds${_type}`)
      if(feedsList.data.success) {
        list[type] = feedsList.data.data.slice(0,9)
      }

      this.types = this.types.map(x => {
        return {
          ...x,
          active: x.id === type
        }
      })
      this.list = list[type];

      // if(type === 'news') {
      //   this.list.map(item => {
      //     item.link_url = `/fans/news/detail/${item.link_url.split('b_id=')[1]}`;
      //   })
      // }

    },
    imageSrc(imgSrc) {
      return require('@/assets/img/'+imgSrc);
    },
    replaceByDefaultImg(e) {
      e.target.src = require('@/assets/img/feed_default.png');
    }
  }
}
</script>
<style scoped>
@media (max-width: 959px) {
  .mainNews .container .tabBtn .btn {
    padding: 0 3px 12px 3px;
  }
}
</style>
